import { render, staticRenderFns } from "./CollectionPerformanceDataAnalyse.vue?vue&type=template&id=8fa7965a&scoped=true&"
import script from "./CollectionPerformanceDataAnalyse.vue?vue&type=script&lang=js&"
export * from "./CollectionPerformanceDataAnalyse.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPerformanceDataAnalyse.vue?vue&type=style&index=0&id=8fa7965a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa7965a",
  null
  
)

export default component.exports